import { render, staticRenderFns } from "./EditSkill.vue?vue&type=template&id=a3474cb8&scoped=true"
import script from "./EditSkill.vue?vue&type=script&lang=js"
export * from "./EditSkill.vue?vue&type=script&lang=js"
import style0 from "./EditSkill.vue?vue&type=style&index=0&id=a3474cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3474cb8",
  null
  
)

export default component.exports